import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Badge, Table, ProgressBar } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import GifLoder from '../../components/GifLoder';
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from "primereact/dialog";
import { GiCheckMark } from "react-icons/gi";
import ClientSearchDialog from '../../modalPopup/ClientSearchDialog';
import CustomToast from '../../components/CustomToast';
const Client_form_responses = () => {
    const { accessToken, userId, role } = useAuth();
    const navigate = useNavigate();
    const { type } = useParams();
  const toastRef = useRef(null);
    const [forms, setForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({});
    const [currentStep, setCurrentStep] = useState(0);
    const [duplicatedSections, setDuplicatedSections] = useState({});
    const [visible, setVisible] = useState(true);
    const [isClientDialogVisible, setIsClientDialogVisible] = useState(false);
    const [ClientId, setClientId] = useState(null); // Store selected Client ID
    const [transition, setTransition] = useState(''); // Manage transition state
    const handleNavigation = (path, animationClass) => {
        setTransition(animationClass); // Set the animation class
        setTimeout(() => {
            if (path === -1) {
                navigate(-1); // Go back
            } else {
                navigate(path); // Navigate to a specific path
            }
            setTransition(''); // Reset transition state
        }, 800); // Match the animation duration
    };


    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
      };



    // Fetch Forms by Category
    const fetchForms = async (type) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/ClientFormRoutes/fetch-forms?type=${type}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`, // Include auth header
                    },
                }
            );

            setForms(response.data);

            // Automatically select the first form if available
            if (response.data.length > 0) {
                setSelectedForm(response.data[0]);
            } else {
                setSelectedForm(null);
            }
        } catch (err) {
            console.error("Error fetching forms:", err);
            setSelectedForm(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchForms(type);
    }, [type, accessToken]);



    const handleChange = (sectionId, fieldId, value, isDuplicate = false, duplicateId = null) => {
        if (isDuplicate && duplicateId) {
            setFormData((prev) => ({
                ...prev,
                [duplicateId]: {
                    ...prev[duplicateId],
                    [fieldId]: value
                }
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [sectionId]: {
                    ...prev[sectionId],
                    [fieldId]: value
                }
            }));
        }
    };


    /*-------------------Steep_count------------------*/

    const totalSteps = selectedForm?.sections
        ? Object.keys(
            selectedForm.sections.reduce((acc, section) => {
                acc[section.step] = acc[section.step] || [];
                acc[section.step].push(section);
                return acc;
            }, {})
        ).length
        : 0;


    const progressPercentage = ((currentStep + 1) / totalSteps) * 100;

    const nextStep = () => {
        setCurrentStep((prev) => Math.min(prev + 1, selectedForm.sections.length - 1));
    };

    const prevStep = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };

    const duplicateSection = (section) => {
        setDuplicatedSections((prev) => {
            const duplicateId = `dup-${Date.now()}`; // Unique ID for each duplicate

            // Deep copy the section and its fields, ensuring unique field IDs
            const newDuplicate = {
                id: duplicateId,
                section_name: section.section_name,
                step: section.step,
                fields: section.fields.map(field => ({
                    ...field,
                    id: `${duplicateId}-${field.form_fields_id}`, // Unique field ID per duplicate
                }))
            };

            return {
                ...prev,
                [section.form_section_id]: [...(prev[section.form_section_id] || []), newDuplicate],
            };
        });
    };



    const removeDuplicatedSection = (sectionId, duplicateId) => {
        setDuplicatedSections((prev) => ({
            ...prev,
            [sectionId]: prev[sectionId].filter((dup) => dup.id !== duplicateId),
        }));
    };



    const handleSubmit = async () => {
        if (!selectedForm) return;

        let hasMissingData = false;
        const submissionData = {
            form_name: selectedForm.form_name,
            type: type,
            submission_date: new Date().toISOString(),
            Client_id: ClientId, // Will update this if needed
            responses: [],
        };

        // Check required fields
        selectedForm.sections.forEach((section) => {
            section.fields.forEach((field) => {
                let responseValue = formData?.[section.form_section_id]?.[field.form_fields_id] || "";

                if (field.is_required && !responseValue) {
                    hasMissingData = true;
                } else if (!field.is_required && !responseValue) {
                    responseValue = "N/A";
                }

                submissionData.responses.push({
                    section_name: section.section_name,
                    step: section.step,
                    field_label: field.field_label,
                    input_type: field.input_type,
                    response: responseValue,
                });
            });

            // Handle duplicated sections
            if (duplicatedSections[section.form_section_id]) {
                duplicatedSections[section.form_section_id].forEach((dup, index) => {
                    const sectionNumber = index + 2;
                    dup.fields.forEach((field) => {
                        let responseValue = formData?.[dup.id]?.[field.id] || "";

                        if (field.is_required && !responseValue) {
                            hasMissingData = true;
                        } else if (!field.is_required && !responseValue) {
                            responseValue = "N/A";
                        }

                        submissionData.responses.push({
                            section_name: `${section.section_name} ${sectionNumber}`,
                            step: section.step,
                            field_label: field.field_label,
                            input_type: field.input_type,
                            response: responseValue,
                        });
                    });
                });
            }
        });

        // Prevent submission if required fields are missing
        if (hasMissingData) {
            showMessage("error", "Please fill in all required fields before submitting.");
            return;
        }

        // If Client ID is missing, show the popup
        if (!ClientId) {
            setIsClientDialogVisible(true);
            return;
        }

        // Proceed with form submission after selecting client
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/ClientFormRoutes/admin-submit-form`,
                submissionData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`, // Include Auth Token
                    },
                }
            );
        
            if (response.status === 201) {
                navigate("/Graphe/dashboard/Client_Submitted_form", { replace: true });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    // Function to handle client selection and proceed with submission
    const handleClientSelect = (client) => {
        setClientId(client.Client_id); // Set selected client ID
        setIsClientDialogVisible(false); // Close the dialog
        handleSubmit(); // Re-attempt form submission now that Client ID is set
    };



    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }





    return (
        <>
            <Container className="pt-5">
                <Row className="pt-5 mb-3">
                    <Breadcrumb>
                        <Breadcrumb.Item
                            onClick={() => handleNavigation(-1, 'slide-right')}
                        >
                            <i className="pi pi-angle-left"></i> Back
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Wedding Onboarding Form</Breadcrumb.Item>
                    </Breadcrumb>
                </Row>
                <Row className="mx-0 justify-content-center pt-3 serviceCol">

                    <Col lg={3} className="">
                        <Card className="sticky-top h-auto shadow-sm">
                            {forms.length > 0 ? (
                                forms.map((form) => (
                                    <div
                                        key={form.form_id}
                                        className={`rounded-lg p-2 clickable 
                                ${selectedForm?.form_id === form.form_id ? "text-white activebgcolor" : "bg-white text-dark inactivebgcolor"}`}
                                        onClick={() => {
                                            setSelectedForm(form);
                                            setCurrentStep(0);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >

                                        <div className="d-flex justify-content-between align-items-center p-3" style={{ border: '1px dashed #14a8b6', borderRadius: '6px' }}>
                                            <h6 className="mb-0 text-black">
                                                {form.form_name}
                                                <small className="text-muted mb-0 mt-1 d-block" style={{ fontWeight: '400' }}>
                                                    {form.description}
                                                </small>
                                            </h6>

                                        </div>

                                    </div>
                                ))
                            ) : (
                                <p className="p-4">No forms available for this category.</p>
                            )}
                        </Card>
                    </Col>
                    <Col lg={9} className="">
                        {selectedForm ? (
                            <Card className="mt-6 shadow-0 border">
                                <Card.Header>
                                    <div>
                                        <h6 className="mb-0">{selectedForm.form_name}</h6>
                                        <p className="mb-0 text-muted"><small>{selectedForm.description}</small></p>
                                    </div>
                                    <div className="d-flex justify-content-left pt-4 pb-5 w-100">
                                        <div className="w-100 position-relative">
                                            <ProgressBar now={progressPercentage} variant="success" />
                                            <div className="d-flex justify-content-between position-absolute w-100" style={{ top: "-10px" }}>
                                                {Array.from({ length: totalSteps }, (_, index) => (
                                                    <div key={index} className="position-relative text-center">
                                                        <div
                                                            className={`rounded-circle d-flex align-items-center justify-content-center 
                                                                            ${index <= currentStep ? "bg-success text-white" : "bg-light border"}
                                                                        `}
                                                            style={{ width: "24px", height: "24px" }}
                                                        >
                                                            {index <= currentStep && <GiCheckMark size={16} />}
                                                        </div>
                                                        <div className="mt-2" style={{ fontSize: "14px" }}>Step {index + 1}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Card.Header>

                                <Card.Body>
                                    {/* Group sections by step */}
                                    {Object.entries(
                                        selectedForm.sections.reduce((acc, section) => {
                                            acc[section.step] = acc[section.step] || [];
                                            acc[section.step].push(section);
                                            return acc;
                                        }, {})
                                    )
                                        .sort(([stepA], [stepB]) => stepA - stepB) // Sort steps
                                        .map(([step, sections], index) =>
                                            currentStep === index ? (
                                                <div key={step} >
                                                    {sections.map((section) => (
                                                        <div key={section.form_section_id} className="mb-4" >
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <h6>{section.section_name}</h6>
                                                                {section.is_repeatable && (
                                                                    <Button
                                                                        label="Add"
                                                                        icon="pi pi-plus"
                                                                        className="p-0"
                                                                        text
                                                                        severity="danger"
                                                                        onClick={() => duplicateSection(section)}
                                                                    />
                                                                )}
                                                            </div>

                                                            <div className="mt-2 d-flex flex-wrap gap-2 justify-content-between">
                                                                {section.fields.map((field) => (
                                                                    <div key={field.form_fields_id} className="mt-2" style={{ width: '48.5%' }}>
                                                                        <label className="block font-medium mb-2">{field.field_label} {field.is_required && <sup className="text-danger">*</sup>}</label>

                                                                        {field.input_type === "text" && (
                                                                            <InputText
                                                                                value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                onChange={(e) =>
                                                                                    handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                }
                                                                                className="w-full p-2"
                                                                                required={field.is_required}
                                                                            />
                                                                        )}

                                                                        {field.input_type === "number" && (
                                                                            <InputNumber
                                                                                value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                onValueChange={(e) =>
                                                                                    handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                }
                                                                                className="w-full"
                                                                                required={field.is_required}
                                                                            />
                                                                        )}

                                                                        {field.input_type === "email" && (
                                                                            <InputText
                                                                                type="email"
                                                                                value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                onChange={(e) =>
                                                                                    handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                }
                                                                                className="w-full p-2"
                                                                                required={field.is_required}
                                                                            />
                                                                        )}

                                                                        {field.input_type === "date" && (
                                                                            <Calendar
                                                                                value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                onChange={(e) =>
                                                                                    handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                }
                                                                                className="w-full"
                                                                                required={field.is_required}
                                                                            />
                                                                        )}

                                                                        {field.input_type === "textarea" && (
                                                                            <InputTextarea
                                                                                value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                onChange={(e) =>
                                                                                    handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                }
                                                                                rows={4}
                                                                                className="w-full p-2 h-auto"
                                                                                required={field.is_required}
                                                                            />
                                                                        )}

                                                                        {field.input_type === "select" && field.options && (
                                                                            <Dropdown
                                                                                value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                options={field.options.split(",").map((option) => ({
                                                                                    label: option.trim(),
                                                                                    value: option.trim(),
                                                                                }))}
                                                                                onChange={(e) =>
                                                                                    handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                }
                                                                                placeholder="Select an option"
                                                                                className="w-full"
                                                                                required={field.is_required}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Display Duplicated Sections */}
                                                            {section.is_repeatable && duplicatedSections[section.form_section_id]?.length > 0 &&
                                                                duplicatedSections[section.form_section_id].map((dup, i) => (
                                                                    <div key={dup.id} className="mt-3 oddSteplist d-flex flex-wrap gap-2 justify-content-between">
                                                                        <div className="d-flex justify-content-between align-items-center pb-2 mb-3" style={{ width: '100%' }}>
                                                                            <h6>{section.section_name} {i + 2}</h6>
                                                                            <Button
                                                                                title="Remove"
                                                                                icon="pi pi-trash"
                                                                                className="p-0"
                                                                                text
                                                                                severity="danger"
                                                                                onClick={() => removeDuplicatedSection(section.form_section_id, dup.id)}
                                                                            />
                                                                        </div>

                                                                        {dup.fields.map((field) => (
                                                                            <div key={field.id} className="mt-2" style={{ width: '48.5%' }}>
                                                                                <label className="d-block mb-2">{field.field_label}</label>

                                                                                {field.input_type === "text" && (
                                                                                    <InputText
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.target.value, true, dup.id)
                                                                                        }
                                                                                        className="w-full p-2 bg-gray-200"
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "number" && (
                                                                                    <InputNumber
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onValueChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.value, true, dup.id)
                                                                                        }
                                                                                        className="w-full bg-gray-200"
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "email" && (
                                                                                    <InputText
                                                                                        type="email"
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.target.value, true, dup.id)
                                                                                        }
                                                                                        className="w-full p-2 bg-gray-200"
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "date" && (
                                                                                    <Calendar
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.value, true, dup.id)
                                                                                        }
                                                                                        className="w-full bg-gray-200"
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "textarea" && (
                                                                                    <InputTextarea
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.target.value, true, dup.id)
                                                                                        }
                                                                                        rows={4}
                                                                                        className="w-full p-2 bg-gray-200 h-auto"
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "select" && field.options && (
                                                                                    <Dropdown
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        options={field.options.split(",").map((option) => ({
                                                                                            label: option.trim(),
                                                                                            value: option.trim(),
                                                                                        }))}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.value, true, dup.id)
                                                                                        }
                                                                                        className="w-full bg-gray-200"
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        ))}

                                                                    </div>
                                                                ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : null
                                        )}
                                </Card.Body>

                                <Card.Footer className="d-flex justify-content-end align-items-center px-2">
                                    <Button
                                        label="Back"
                                        icon="pi pi-arrow-left"
                                        className="py-2"
                                        disabled={currentStep === 0}
                                        onClick={prevStep}
                                        severity="primary"
                                    />
                                    {currentStep === Object.keys(
                                        selectedForm.sections.reduce((acc, section) => {
                                            acc[section.step] = acc[section.step] || [];
                                            acc[section.step].push(section);
                                            return acc;
                                        }, {})
                                    ).length - 1 ? (
                                        <Button
                                            label="Submit"
                                            icon="pi pi-check"
                                            className="py-2 ms-2"
                                            severity="success"
                                            onClick={handleSubmit} // Call handleSubmit on click
                                        />

                                    ) : (
                                        <Button
                                            label="Next"
                                            icon="pi pi-arrow-right"
                                            className="ms-2 py-2"
                                            onClick={nextStep}
                                            severity="primary"
                                            iconPos="right"
                                        />
                                    )}
                                </Card.Footer>
                            </Card>
                        ) : (
                            <Card className=" shadow-0">
                                <Card.Body>
                                    <p className="p-1 mb-0 text-center">No form selected.</p>
                                </Card.Body>
                            </Card>
                        )}
                    </Col>




                </Row>
                <Dialog
                    visible={visible}
                    onHide={() => setVisible(false)}
                    modal
                    header="Information"
                    closable={true}
                    draggable={false}
                    style={{ width: "320px" }}
                >
                    <p>If the client is not registered, please register the client first.</p>
                    <div className="d-flex justify-content-center">
                        <Button
                            label="Register Client"
                            icon="pi pi-user-plus"
                            severity="warning"
                            className="py-2 border-0"
                            onClick={() => navigate("/Graphe/dashboard/client_link_list")}
                        />
                    </div>
                </Dialog>

                <ClientSearchDialog
                    visible={isClientDialogVisible}
                    onHide={() => setIsClientDialogVisible(false)}
                    closable={false}
                    draggable={false}
                    onSelectClient={handleClientSelect}
                />


            </Container>
            <div className={`transition-overlay ${transition}`} />
            <CustomToast ref={toastRef} />
        </>
    );
}
export default Client_form_responses;
